
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.671 8.368H18v-.035h-7.5v3.334h4.71A4.998 4.998 0 015.5 10a5 5 0 015-5c1.274 0 2.434.48 3.317 1.266l2.357-2.357A8.295 8.295 0 0010.5 1.667a8.334 8.334 0 108.171 6.7z","fill":"#FFC107"}}),_c('path',{attrs:{"d":"M3.127 6.121L5.865 8.13A4.998 4.998 0 0110.5 5c1.274 0 2.434.48 3.317 1.266l2.357-2.357A8.295 8.295 0 0010.5 1.667 8.329 8.329 0 003.127 6.12z","fill":"#FF3D00"}}),_c('path',{attrs:{"d":"M10.5 18.333a8.294 8.294 0 005.587-2.163l-2.58-2.183A4.962 4.962 0 0110.5 15a4.998 4.998 0 01-4.701-3.31L3.08 13.782a8.327 8.327 0 007.419 4.55z","fill":"#4CAF50"}}),_c('path',{attrs:{"d":"M18.671 8.368H18v-.035h-7.5v3.334h4.71a5.017 5.017 0 01-1.703 2.321l2.58 2.182c-.182.165 2.746-2.003 2.746-6.17 0-.559-.057-1.104-.162-1.632z","fill":"#1976D2"}})])
          )
        }
      }
    